import React, { useCallback, useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import EmptyComponent from 'design-system/EmptyComponent';
import useDisableAndroidBackButton from 'hooks/useDisableAndroidBackButton';
import StatusBar from 'design-system/StatusBar';
import FeatureIntroduction from 'design-system/FeatureIntroduction';
import { IconTwoUser } from 'design-system/icons/IconTwoUser';
import { IconSettings } from 'design-system/icons/IconSettings';
import { IconShare } from 'design-system/icons/IconShare';
import IconSpace from 'design-system/icons/IconSpace';
import links from 'utils/links';
import { isWeb } from '../../constants';
const strings = {
    title: 'Introducing spaces',
    subTitle: 'Great for business owners, self-employed and families',
    infoText: 'Curious about how Spaces can help you?\n',
    continueButton: 'Continue',
};
const SPACES_INTRO_ITEMS = [
    {
        icon: <IconTwoUser gradientKey="darkPink"/>,
        title: 'Group',
        description: 'Group your accounts in Spaces and set different budgets',
    },
    {
        icon: <IconSettings gradientKey="orange"/>,
        title: 'Manage',
        description: 'Manage your personal, joint and business accounts all in Emma.',
    },
    {
        icon: <IconShare gradientKey="skyBlue"/>,
        title: 'Share',
        description: 'Share Spaces with your partner(s) and allow them to use Pro features such as Custom Categories.',
    },
];
const SpacesIntro = React.memo(({ route, navigation }) => {
    const onContinue = route.params?.onContinue;
    useLayoutEffect(() => {
        navigation.setOptions({
            ...(isWeb ? { title: strings.title, headerShown: false } : {}),
            gestureEnabled: false,
            headerLeft: EmptyComponent,
        });
    }, []);
    const onHelpPress = useCallback(() => {
        links.openKnownLink('spacesHelp');
    }, []);
    useDisableAndroidBackButton(onContinue);
    return (<View style={styles.container}>
        <StatusBar barStyle="dark-content" animated/>
        <FeatureIntroduction title={strings.title} subTitle={strings.subTitle} items={SPACES_INTRO_ITEMS} buttonText={strings.continueButton} onPressNext={onContinue} topIcon={<IconSpace colorKey="brand"/>} infoCard={{ onPressInfo: onHelpPress, infoText: strings.infoText }}/>
      </View>);
});
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
export default SpacesIntro;
